export default __webpack_public_path__ + "static/media/driver.da7338e7.svg";